export const getRestoringState = state => state.restoringState;
export const getFormValues = state => ({
  productName: state.productName,
  productDescription: state.productDescription,
  keywordType: state.keywordType,
  keywords: state.keywords,
  excludeOldWorkItems: state.excludeOldWorkItems,
  customKeywordsMustMatch: state.customKeywordsMustMatch,
});
